<template>
    <v-card flat tile :to="`/programs/${value._id}`">
        <v-card outlined rounded="lg" class="mb-24">
            <v-img :src="value.thumb?.src" :aspect-ratio="282 / 438" class="grey-f7">
                <template #placeholder>
                    <v-overlay absolute light color="white">
                        <image-overlay>{{ value.host.name }}</image-overlay>
                    </v-overlay>
                </template>
            </v-img>
        </v-card>
        <div class="mb-24">
            <h5 class="page-text--lg mb-8">{{ value.subject }}</h5>
            <div>
                <p class="page-text primary--text mb-4">{{ value.host.name }}</p>
                <p class="page-text ma-0">{{ value.date.programDisplay.text }}</p>
            </div>
        </div>
        <v-chip-group>
            <v-chip outlined label>
                <span class="font-size-14"> {{ value._employees.length.format() }}명 참여 </span>
            </v-chip>
            <v-chip outlined label>
                <span class="font-size-14"> {{ value._employers.length.format() }}개 기업 참여 </span>
            </v-chip>
        </v-chip-group>
    </v-card>
</template>

<script>
import { initExpoProgram } from "@/assets/variables/inits";

import ImageOverlay from "@/components/dumb/image-overlay.vue";

export default {
    components: {
        ImageOverlay,
    },
    props: {
        value: { type: Object, default: initExpoProgram },
    },
};
</script>
